module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img29.656a49ba.jpg";